import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { fileUrl } from '../../salesApi';
import { useT } from '../../salesI18n';
import { MarksOverlay } from './MarkedPhoto';
import { IllustrativeBadge } from '../../../components/IllustrativeBadge';

// Foto em tela cheia (portal no body) com as medidas marcadas. Fecha no X, Esc ou toque no fundo.
// pointer-events: auto → funciona mesmo com um Dialog (Radix) aberto por baixo. data-lightbox → o Dialog ignora o clique como "fora".
// z-index 100000: App.css força [role=dialog] em 99999, então o lightbox precisa ficar acima do modal de abertura.
export const ImageLightbox = ({ fileId, marks = [], measures = {}, note, onClose, testId = 'image-lightbox' }) => {
  const { t } = useT();
  useEffect(() => {
    if (!fileId) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onClose(); } };
    window.addEventListener('keydown', onKey, true);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey, true); document.body.style.overflow = prev; };
  }, [fileId, onClose]);
  if (!fileId) return null;
  return createPortal(
    <div className="fixed inset-0 bg-black/95 flex items-center justify-center p-3" style={{ pointerEvents: 'auto', zIndex: 100000 }} onClick={onClose} data-lightbox="1" data-testid={testId}>
      <button type="button" onClick={onClose} className="absolute right-3 h-11 w-11 rounded-full bg-white text-slate-900 flex items-center justify-center shadow-lg hover:scale-105 transition-transform z-10" style={{ top: 'calc(0.75rem + env(safe-area-inset-top))' }} aria-label={t.close} data-testid={`${testId}-close`}><X className="h-5 w-5" /></button>
      <span className="relative inline-block leading-none" onClick={(e) => e.stopPropagation()}>
        <img src={fileUrl(fileId)} alt="" className="block w-auto h-auto max-w-[calc(100vw-1.5rem)] max-h-[calc(100dvh-1.5rem)] rounded-xl select-none" draggable={false} data-testid={`${testId}-img`} />
        <MarksOverlay marks={marks} measures={measures} />
        {note && <IllustrativeBadge text={note} className="bottom-3 right-3" testId={`${testId}-illustrative`} />}
      </span>
    </div>,
    document.body,
  );
};
